export default __webpack_public_path__ + "static/choose-19d10155c01fee62cdc65e7406693f59.jpg";